import { WorkOffers } from "../modules";

export const WorkOffersPage = () => {
  return <WorkOffers />;
};
